module.exports = __webpack_public_path__ + "img/1489645074.d1bb0eee.jpg";